import { render, staticRenderFns } from "./SecondarySelect.vue?vue&type=template&id=ee6e0aa6&"
import script from "./SecondarySelect.vue?vue&type=script&lang=js&"
export * from "./SecondarySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports